export enum PpWindowState {
    WindowStateNormal = 1,
    WindowStateMinimize = 2,
    WindowStateMaximize = 3,
}
